import React, { FC, memo, useEffect, useState } from 'react'
import classes from './InputComment.module.scss'
import { Edit } from '@mui/icons-material'
import { Box, Modal, TextField, useMediaQuery, useTheme } from '@mui/material'
import SingleInputMain from '../../../singleInput/SingleInputMain'
import { useRecoilState } from 'recoil'
import {
  fetchManageStateForList,
  fetchManageStateForMatrix,
} from '../../../../states/fetchMnageState'
import { formatWorkerId } from '../../../../utils/variables/workerId'
type Props = {
  workerId: string
  dateString: string
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>
  callFrom: string
  initialProductNo?: string
  initialProductBno?: string
}

const SingleInputModal: FC<Props> = memo((props) => {
  const [fetchDiaryList, setFetchDiaryList] = useRecoilState(
    fetchManageStateForList
  )
  const [fetchDiaryMatrix, setFetchDiaryMatrix] = useRecoilState(
    fetchManageStateForMatrix
  )

  const theme = useTheme()
  const isIphone = useMediaQuery(theme.breakpoints.down('sm'))
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isNotePc = useMediaQuery(theme.breakpoints.down('lg'))
  const {
    workerId,
    dateString,
    setIsShow,
    callFrom,
    initialProductNo,
    initialProductBno,
  } = props
  //   console.log("デバッグ", dateString, workerId);

  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
    setIsShow(false)
  }
  // useEffect(() => {
  //   if (callFrom === 'list') {
  //     setFetchDiaryList(!fetchDiaryList);
  //   } else {
  //     setFetchDiaryMatrix(!fetchDiaryMatrix);
  //   }
  // }, []);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: 'none',
        '&:focus-visible': {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
        // zIndex: 100,
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.backColor.main,
          display: 'flex',
          flexDirection: 'column',
          //   flexGrow: 1,
          //   width: "100%",
          alignItems: 'center',
          width: isIphone
            ? '375px'
            : isMobile
            ? '700px'
            : isNotePc
            ? '600px'
            : '600px',
          position: 'absolute',
          borderRadius: '5px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: isIphone
            ? '600px'
            : isMobile
            ? '900px'
            : isNotePc
            ? '500px'
            : '800px',
        }}
      >
        <SingleInputMain
          fromOtherPage={true}
          setIsShow={setIsShow}
          dateStringFromOtherPage={dateString}
          workerIdFromOtherPage={formatWorkerId(workerId)}
          callFrom={callFrom}
          initialProductNo={initialProductNo}
          initialProductBno={initialProductBno}
        />
      </Box>
    </Modal>
  )
})

export default SingleInputModal
